module.exports = __webpack_public_path__ + "videos/loader-animation-108px.2de0c45.webm";